import { FC } from 'react';
import Link from 'next/link';
import styles from './CheckboxFreeBook.module.scss';

interface ICheckBoxFreeBook {
  freeBooks: boolean;
  alias: string;
  extraClassName?: string;
}

const CheckBoxFreeBook: FC<ICheckBoxFreeBook> = ({ freeBooks = false, alias, extraClassName }) => {
  return (
    <div className={extraClassName ? `${styles.checkBox} ${styles[`${extraClassName}`]}` : `${styles.checkBox}`}>
      <Link prefetch={false} className={freeBooks ? `${styles.checkBox__btn} ${styles.checkBox__btn_active}` : styles.checkBox__btn} href={freeBooks ? alias : `${alias}/?free_books=true`}>
        Полная версия
      </Link>
    </div>
  );
};
export default CheckBoxFreeBook;
